import React from 'react';

interface GapProps {
  gap: 4 | 8 | 12 | 16 | 20 | 24 | 32;
}

const Gap: React.FC<GapProps> = ({ gap }) => {
  return <div style={{ marginBottom: `${gap}px` }} />;
};

export default Gap;
